import { defineMessages } from 'react-intl';

export default defineMessages({
  addRecipientRecipientButton: {
    id: '',
    description: 'Button that adds new recipient row',
    defaultMessage: 'Add another recipient',
  },
  addRecipientSignerButton: {
    id: '',
    description: 'Button that adds new recipient row',
    defaultMessage: 'Add another signer',
  },
  addSelfAsSignerButton: {
    id: '',
    description: 'Button that adds current user info as the recipient',
    defaultMessage: 'Add me as a signer',
  },
  addRecipientRoleButton: {
    id: '',
    description: 'Button that adds new recipient row',
    defaultMessage: 'Add another role',
  },
  enableReassignmentCheckbox: {
    id: '',
    description: 'Checkbox for enabling signer reassignment',
    defaultMessage: 'Enable signer reassignment',
  },
  setOrderCheckbox: {
    id: '',
    description: 'Checkbox for enabling changing signer order',
    defaultMessage: 'Set signer order',
  },
  fieldNameLabel: {
    id: '',
    description: 'Label for name field',
    defaultMessage: 'Name',
  },
  fieldNamePlaceholder: {
    id: '',
    description: 'Placeholder for name field',
    defaultMessage: "Signer's name",
  },
  fieldEmailLabel: {
    id: '',
    description: 'Label for email address field',
    defaultMessage: 'Email address',
  },
  fieldEmailPlaceholder: {
    id: '',
    description: 'Placeholder for email address field',
    defaultMessage: 'email@example.com',
  },
  fieldRoleLabel: {
    id: '',
    description: 'Label for role field',
    defaultMessage: 'Role title',
  },
  fieldRolePlaceholder: {
    id: '',
    description: 'Placeholder for role field',
    defaultMessage: 'Signing role (Manager, Client)',
  },
  fieldFaxLabel: {
    id: '',
    description: 'Label for fax field',
    defaultMessage: 'Fax number or email',
  },
  fieldFaxPlaceholder: {
    id: '',
    description: 'Placeholder for fax field',
    defaultMessage: '+1 555-123-4567 or email@example.com',
  },
  fieldAccessCodeBody: {
    id: '',
    description: 'Body for access code field',
    defaultMessage: 'The signer will be required to enter the access code you specify below to view and sign the document. Access code is case sensitive.',
  },
  accessCodeLabel: {
    id: '',
    description: 'Access code',
    defaultMessage: 'Access code',
  },
  accessCode: {
    id: '',
    description: 'Access Code',
    defaultMessage: 'Access Code',
  },
  accessCodeSave: {
    id: '',
    description: 'Access Code save button',
    defaultMessage: 'Save and close',
  },
  accessCodeTitle: {
    id: '',
    description: 'Access Code modal title',
    defaultMessage: 'Create an access code',
  },
  accessCodeTooltip: {
    id: '',
    description: 'Tooltip on Access Code button',
    defaultMessage: 'Create an access code',
  },
  fieldSmsAuthNumberBody: {
    id: '',
    description: 'Body for signer sms authentication field',
    defaultMessage: 'The signer will be required to enter the code sent via SMS to the number you specify below to view and sign the document.',
  },
  smsAuthNumberLabel: {
    id: '',
    description: 'Signer SMS Authentication',
    defaultMessage: 'Signer SMS Authentication',
  },
  smsAuthNumber: {
    id: '',
    description: 'Signer SMS Authentication',
    defaultMessage: 'Signer SMS Authentication',
  },
  smsAuthNumberSave: {
    id: '',
    description: 'Signer SMS authentication save button',
    defaultMessage: 'Save and close',
  },
  smsAuthNumberTitle: {
    id: '',
    description: 'Signer SMS authentication modal title',
    defaultMessage: 'Add an SMS authentication number',
  },
  smsAuthNumberTooltip: {
    id: '',
    description: 'Tooltip on Signer SMS Authentication button',
    defaultMessage: 'Add an SMS authentication number',
  },
  signerReassignmentTooltip: {
    id: '',
    description: 'Tooltip on Enable Signer Reassignment help icon',
    defaultMessage: 'Signers can assign someone else to sign this document',
  },
  delete: {
    id: '',
    description: 'Delete',
    defaultMessage: 'Delete',
  },
  removeRecipientTooltip: {
    id: '',
    description: 'Tooltip on Remove Recipients button',
    defaultMessage: 'Remove recipient',
  },
  removeSigner: {
    id: '',
    description: 'Remove signer text button',
    defaultMessage: 'Remove signer',
  },
  headerSignersPage: {
    id: '',
    description: 'text for signers page header',
    defaultMessage: 'Who needs to sign?',
  },
  headerAddSigners: {
    id: '',
    description: 'text for add signers header',
    defaultMessage: 'Add Signers',
  },
  headerAddSignerRoles: {
    id: '',
    description: 'text for add signers header',
    defaultMessage: 'Add Signer roles',
  },
  headerUploadCSV: {
    id: '',
    description: 'text for signers header for bulk send',
    defaultMessage: 'Upload CSV of signers',
  },
  signerType: {
    id: '',
    description: 'Will be used to prefix a signer\'s name in other messages',
    defaultMessage: 'Signer',
  },
  roleType: {
    id: '',
    description: 'Will be used to prefix a role\'s name in other messages',
    defaultMessage: 'Role',
  },
  meNowSignerButton: {
    id: '',
    description: 'text for me now button',
    defaultMessage: 'I\'m the only signer',
  },
  meNowSignerTitle: {
    id: '',
    description: 'title for only signer warning modal',
    defaultMessage: 'Continue as only signer?',
  },
  meNowSignerContent: {
    id: '',
    description: 'body message for only signer warning modal',
    defaultMessage: 'Signer names, email addresses, attachment requests, and settings you\'ve specified will be removed from this signature request.',
  },
  cancel: {
    id: '',
    description: 'button text that closes modal only signer modal',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: '',
    description: 'button text that confirms user choice for only signer modal',
    defaultMessage: 'Confirm',
  },
  signerCSVSubText: {
    id: '',
    description: 'text for upload csv header subtext',
    defaultMessage: 'Use our <b>CSV template</b> to upload your list of signers. Need help? Learn more about <a>how to send requests in bulk</a>.',
  },
  uploadCSVButton: {
    id: '',
    description: 'text for Upload CSV button',
    defaultMessage: 'Upload CSV',
  },
  csvValidationError: {
    id: '',
    description: 'text for displaying csv validation error',
    defaultMessage: 'There was a validation error: {error}',
  },
  canNotContinue: {
    id: '',
    description: 'Generic error when user is out of quota',
    defaultMessage: 'You can not continue',
  },
  recipientDropdownLabel: {
    id: '',
    description: 'Dropdown menu that shows recipient options to select from',
    defaultMessage: 'Click to show more options',
  },
  authenticationMethodLabel: {
    id: '',
    description: 'Dropdown menu for sender to select recipient authentication method',
    defaultMessage: 'Authentication method',
  },
  recipientCodeLabel: {
    id: '',
    description: 'Text field for sender to specify an access code for recipient',
    defaultMessage: 'Code (case sensitive)',
  },
  recipientPhoneNumberLabel: {
    id: '',
    description: 'Text field for sender to specify a phone number for recipient to receive SMS code',
    defaultMessage: 'Phone number',
  },
  recipientMobilePhoneNumberLabel: {
    id: '',
    description: 'Text field for sender to specify a mobile phone number for recipient to receive signature request',
    defaultMessage: 'Mobile phone number',
  },
  fieldMobilePhonePlaceholder: {
    id: '',
    description: 'Placeholder for mobile phone number',
    defaultMessage: '+1 555-123-4567',
  },
  recipientAuthenticationMethodLabel: {
    id: '',
    description: 'Label for section where sender sets the signer authentication for the request',
    defaultMessage: 'Authentication method',
  },
  recipientAuthenticationDropdownLabel: {
    id: '',
    description: 'Label for dropdown for sender to select which type of signer authentication to use',
    defaultMessage: 'Select method',
  },
  recipientAuthenticationDropdownSmsAuth: {
    id: '',
    description: 'Dropdown item for sender to select signer SMS authentication',
    defaultMessage: 'Text message',
  },
  recipientAccessCodeTooltip: {
    id: '',
    description: 'Tooltip for signer access code',
    defaultMessage: 'Require signers to enter a custom access code before they can view or sign your documents',
  },
  reassignWithQESTooltip: {
    id: '',
    description: 'Disabled Recipient Reassignment message',
    defaultMessage: 'Unable to reassign when Qualified eSignature is selected',
  },
  reassignWithSmsDeliveryTooltip: {
    id: '',
    description: 'Disabled Recipient Reassignment message',
    defaultMessage: 'Unable to reassign when any signer has Email + SMS delivery',
  },
  reassignWithTemplateTooltip: {
    id: '',
    description: 'Disabled Recipient Reassignment message',
    defaultMessage: 'Changing signer reassignment is not allowed when using template',
  },
  qesWithMultiSignerTooltip: {
    id: '',
    description: 'Disabled QES message',
    defaultMessage: 'Qualified eSignature is only available for one signer per document',
  },
  qesWithReassignTooltip: {
    id: '',
    description: 'Disabled QES message',
    defaultMessage: 'Qualified eSignature is not allowed with signer reassignment',
  },
  qesWithNoSignatureTemplateTooltip: {
    id: '',
    description: 'Disabled QES message',
    defaultMessage: 'Qualified eSignature is not allowed when using template with no signature field',
  },
  prepAndSendDeliveryTypeEmail: {
    id: '',
    description: 'Send a signature request by email only',
    defaultMessage: 'Email',
  },
  prepAndSendDeliveryTypeEmailSms: {
    id: '',
    description: 'Send a signature request with email and SMS',
    defaultMessage: 'Email + SMS',
  },
  smsDeliveryWithReassignTooltip: {
    id: '',
    description: 'Disabled Email + SMS delivery when signer reassignment is enabled',
    defaultMessage: 'Unable to select Email + SMS when signer reassignment is enabled',
  },
  smsDeliveryWithSmsAuthTooltip: {
    id: '',
    description: 'Disabled Email + SMS delivery when signer SMS Auth is enabled',
    defaultMessage: 'To ensure the security of you and your signers, this delivery method isn\'t available with text message authentication',
  },
  maxSmsDeliveryTooltip: {
    id: '',
    description: 'Signature request has exceeded the max number of Email + SMS deliveries',
    defaultMessage: 'You have reached the limit of {maxSmsDeliveries, number} signers per request with text message delivery. If additional signers are needed, select Email. ',
  },
  smsAuthWithSmsDeliveryTooltip: {
    id: '',
    description: 'Disabled SMS Auth when Email + SMS delivery is enabled for signer',
    defaultMessage: 'To ensure the security of you and your signers, text message authentication isn\'t available with this delivery method.',
  },
  unableToAutoUpgradeSmsDelivery: {
    id: '',
    description: 'Disabled Email + SMS delivery when add-on cannot be auto-upgraded to next tier',
    defaultMessage: 'Your team has used all your SMS document sends for the year.\nContact your admin or HelloSign sales to get more.',
  },
  maxSmsAuthTooltip: {
    id: '',
    description: 'Disable SMS Auth if more than 5 and SMS tools is enabled',
    defaultMessage: 'You have reached the limit of {maxSmsAuths, number} signers per request with text message authentication.',
  },
});
